import styled, { css } from 'styled-components'

export const RatingWrapper = styled(
  ({ activeColor, inactiveColor, hoverColor, ...rest }) => <div {...rest} />,
)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .ui.rating {
    ${({ theme }) => theme.mediaQueries.mobile} {
      font-size: 15px;
    }
    .icon {
      font-family: 'Rating' !important;
      line-height: 1;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      font-weight: normal;
      font-style: normal;
      text-align: center;
    }

    .icon.icon.active {
      color: ${props => props.activeColor} !important;
      text-shadow: 0 -1px 0 ${props => props.activeColor},
        -1px 0 0 ${props => props.activeColor},
        0 1px 0 ${props => props.activeColor},
        1px 0 0 ${props => props.activeColor}!important;
      margin-right: 0.3em;
    }

    .icon.icon.selected.active,
    .icon.icon.selected {
      color: ${props => props.hoverColor} !important;
      text-shadow: 0 -1px 0 ${props => props.hoverColor},
        -1px 0 0 ${props => props.hoverColor},
        0 1px 0 ${props => props.hoverColor},
        1px 0 0 ${props => props.hoverColor}!important;
      margin-right: 0.3em;
    }

    .icon:not(.selected):not(.active) {
      color: ${props => props.inactiveColor} !important;
      margin-right: 0.3em;
    }
  }
`

export const SensitiveDot = styled.div`
  ${({ theme }) => css`
    width: 8px;
    height: 8px;
    background: ${theme.colors.abyss};
    margin-left: 4px;
    margin-right: 12px;
    border-radius: 100%;
  `}
`
